
import { NoReportsFound, ReportLoading } from '@/components/reports';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Checkbox } from "@/components/ui/checkbox";
import { SpecialClassTable } from './SpecialClassTable';
import { useSpecialClassReports } from '@/hooks/useSpecialClassReports';
import { UseMutationResult } from '@tanstack/react-query';
import type { Database } from '@/integrations/supabase/types';

interface SpecialClassHeaderProps {
  isLoading: boolean;
  jobs: Database['public']['Views']['job_student_view']['Row'][];
  search: string;
  setSearch: (q: string) => void;
  onSearch: () => void;
  showNotApproveOnly: boolean;
  setShowNotApproveOnly: (b: boolean) => void;
  approveSpecialClassMutation: UseMutationResult<any, Error, { jobId: number, status: "approved" | "rejected", note: string }, unknown>;
}

export function SpecialClassReport({
  isLoading,
  jobs,
  search,
  setSearch,
  onSearch,
  showNotApproveOnly,
  setShowNotApproveOnly,
  approveSpecialClassMutation,
}: SpecialClassHeaderProps) {

  const handleInputKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      onSearch();
    }
  };

  return (
    <Card className="shadow-lg">
      <CardContent className="p-6">
        {/* input ค้นหา */}
        <div className="mb-4 flex flex-col md:flex-row gap-2 md:items-center justify-between">
          <div className="flex w-full max-w-md items-center gap-2">
            <Input
              value={search}
              onChange={e => setSearch(e.target.value)}
              placeholder="ค้นหาด้วยชื่อนักเรียน / ครูผู้สอน / รหัสครู"
              onKeyDown={handleInputKeyDown}
              className="flex-1"
            />
            <Button type="button" onClick={onSearch}>ค้นหา</Button>
          </div>
          <div className="flex items-center space-x-2 mt-2 md:mt-0">
            <Checkbox
              id="notApproveOnly"
              checked={showNotApproveOnly}
              onCheckedChange={v => setShowNotApproveOnly(!!v)}
            />
            <label htmlFor="notApproveOnly" className="text-sm select-none">
              แสดงเฉพาะรายการที่ไม่ได้อนุมัติ
            </label>
          </div>
        </div>
        {isLoading ? (
          <ReportLoading />
        ) : jobs.length > 0 ? (
          <>
            <SpecialClassTable jobs={jobs} approveSpecialClassMutation={approveSpecialClassMutation} />
          </>
        ) : (
          <NoReportsFound />
        )}
      </CardContent>
    </Card>
  );
}
